module.exports = __webpack_public_path__ + "img/beam-body-6.89bde54d.png";